import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Grid } from "@material-ui/core";
import { Header, Footer, FormLogin, ModalLogin } from "~/components/blocks";
import { Breadcrumb } from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import { useDispatch, useSelector } from "react-redux";
import { scrollTo } from "~/utils/tools";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import * as S from "./styles";

export default function Login() {
  const dispatch = useDispatch();
  const mobile = isMobile();

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const errorMessage = useSelector(
    (state) => state.authentication.auth.errorMessage
  );

  const participanteHash = useSelector(
    (state) => state.authentication.auth.user.ParticipanteHash
  );

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Login",
      link: "/login",
    },
  ];

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const handleResend = () => {
    dispatch(SignUpActions.setResendData());
    dispatch(
      SignUpActions.resendConfirmEmail({
        ParticipanteHash: participanteHash,
        url: url,
        origin: origin,
      })
    );
  };

  useEffect(() => {
    scrollTo(700);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Login</title>
      </Helmet>

      <Header />

      <HeroBanner />

      <Breadcrumb navBreadcrumb={navBreadcrumb} />

      {errorMessage && participanteHash ? (
        <ModalLogin message={errorMessage} handleResend={handleResend} />
      ) : null}

      <S.StyledMotionDiv>
        <div className="div" style={{backgroundColor:"#F5F5F5"}}>
          <motion.div
            variants={animations}
            className="single"
            initial="exit"
            animate="enter"
            exit="exit"
          >
            <Grid
              container
              justifyContent="space-between"
              align={mobile ? "center" : "initial"}
            >
              <FormLogin participanteHash={participanteHash} />
            </Grid>
          </motion.div>
        </div>
      </S.StyledMotionDiv>
      <Footer />
    </>
  );
}
